import React from "react";
import { componentMapper } from "@utils/componentMapper";

type Props = {
    id: string;
    title: string;
    type: string;
    references?: any;
};

const FormalizerEntryField = ({ id, references }: Props) => {
    const data = references?.find(c => c?.contentful_id === id);

    if (!data) {
        return <></>;
    }

    return componentMapper(data, undefined) ?? <></>;
};

export default FormalizerEntryField;
